<template>
  <form>
    <v-radio-group v-model="type" row>
      <v-radio label="Incidents" value="incidents"></v-radio>
      <v-radio label="Delays" value="delays"></v-radio>
    </v-radio-group>
    <v-autocomplete
      :items="locations"
      item-value="location"
      item-text="location"
      label="Locations"
      color="blue-grey lighten-2"
      chips
      clearable
      multiple
      deletable-chips
    ></v-autocomplete>
    <v-autocomplete
      :items="causes"
      item-value="cause"
      item-text="cause"
      label="Cause"
      color="blue-grey lighten-2"
      chips
      clearable
      multiple
      deletable-chips
    ></v-autocomplete>
    <h4>Seasons</h4>
    <v-range-slider
      :tick-labels="seasons"
      :value="[1, 2]"
      always-dirty
      min="0"
      max="3"
      thumb-label
      thumb-size="64"
      ticks="always"
    >
      <template v-slot:thumb-label="props">
        <span>
          {{ season(props.value) }}
        </span>
      </template>
    </v-range-slider>
    <h4>Temperature (°C)</h4>
    <v-card-text>
      <v-layout row>
        <v-flex shrink style="width: 60px">
          <v-text-field
            v-model="value3[0]"
            class="mt-0"
            hide-details
            single-line
            type="number"
          ></v-text-field>
        </v-flex>

        <v-flex class="px-3">
          <v-range-slider
            v-model="value3"
            :max="50"
            :min="0"
            :step="1"
          ></v-range-slider>
        </v-flex>

        <v-flex shrink style="width: 60px">
          <v-text-field
            v-model="value3[1]"
            class="mt-0"
            hide-details
            single-line
            type="number"
          ></v-text-field>
        </v-flex>
      </v-layout>
    </v-card-text>
    <v-btn>submit</v-btn>
    <v-btn>clear</v-btn>
  </form>
</template>
<script>
import causes from "./data/cause";
import locations from "./data/location";

export default {
  name: "ORRFilters",
  components: {},
  data() {
    return {
      type: "delays",
      seasons: ["Spring", "Summer", "Autumn", "Winter"],
      causes,
      locations,
      value3: [19, 22]
    };
  },
  methods: {
    season(val) {
      return this.seasons[val];
    },
  },
};
</script>
